// import React, { useState, useEffect, useContext, useRef, useMemo, useCallback } from "react";
// import {
//   Typography,
//   Input,
//   Button,
//   Dropdown,
//   Menu,
//   Icon,
//   message,
//   Result,
//   Tabs,
// } from "antd";
// import { platformApi } from "../../../api";
// import BookingRegisterTable from "./BookingRegisterTable";
// import BookingRegisterModal from "./BookingRegisterModal";
// import ChassisAllocationModal from "./ChassisAllocationModal";
// import PaymentModal from "../../paymentModal";
// import { ContextAPI } from "../../../ContextAPI";
// import { useLocation } from "react-router-dom";
// import BookingHistoryTable from "./BookingHistoryTable";

// const { Title } = Typography;
// const { Search } = Input;
// const { Item } = Menu;
// const { TabPane } = Tabs;
// //default data sturucture
// const defaultData = {
//   bookingId: null,
//   customer: null,
//   customerId: null,
//   customerName: null,
//   customerFatherName: null,
//   customerAddress: null,
//   customerPhone: null,
//   customerLocality: null,
//   customerCountry: null,
//   customerState: null,
//   customerCity: null,
//   customerPincode: null,
//   customerEmail: null,
//   customerDob: null,
//   customerGender: null,
//   IDbranch: null,
//   nomineeName: null,
//   nomineeAge: null,
//   relationship: null,
//   vehicle: null,
//   rto: null,
//   rtoCode: null,
//   rtoArea: null,
//   exchangeVehicleName: null,
//   exchangeVehiclePrice: null,
//   price: null,
//   accessories: [],
//   quotation: [],
//   color: null,
//   loan: null,
//   authentication: null,
//   pdf: "example",
//   pdfSigned: "example",
//   executive: null,
//   remarks: null,
//   bookingStatus: null,
//   authorisedTime: null,
//   refferedBy: null,
// };
// export default function Bookingregister() {
//   const [addFlag, setAddFlag] = useState(false);
//   const [editFlag, setEditFlag] = useState(false);
//   const [bookingType, setBookingType] = useState("ConfirmBooking");
//   const [spinning, setSpinning] = useState(false);
//   const [bookingId, setBookingId] = useState("");
//   const [selectedBooking, setSelectedBooking] = useState(null);
//   const [bookingsData, setBookingsData] = useState([]);
//   const [bFlag, setBFlag] = useState(false);
//   const [limit, setLimit] = useState(10);
//   const [page, setPage] = useState(1);
//   const [count, setCount] = useState(null);
//   const [search, setSearch] = useState(null);
//   const [tab, setTab] = useState(null);
//   const { loginCredintials } = useContext(ContextAPI);
//   const [createAccess, setCreateAccess] = useState(false);
//   const [modifyAccess, setModifyAccess] = useState(false);
//   const [deleteAccess, setDeleteAccess] = useState(false);
//   const [gst, setGst] = useState();
//   const [confirm, setConfirm] = useState(false);
//   const [chassisModal, setChassisModal] = useState(false);
//   const [paymentModalVisible, setPaymentModalVisible] = useState(false);
//   const [selectedRow, setSelectedRow] = useState(null);

//   const location = useLocation();

//   // Memoize menu items to prevent recreation
//   const menuItems = useMemo(() => {
//     if (!count) return [];
//     let size = Math.ceil(count / 10);
//     let menus = [10];
//     size = size <= 10 ? size : 10;
//     for (let itr = 2; itr <= size; itr++) menus.push(itr * 10);
//     return menus.map((menu) => (
//       <Item
//         onClick={() => {
//           setLimit(menu);
//           setPage(1);
//         }}
//         key={menu}
//       >
//         {menu}
//       </Item>
//     ));
//   }, [count]);
//   //
//   useEffect(() => {
//     if (loginCredintials?.branch?.[0]?.gst) {
//       setGst(loginCredintials.branch[0].gst);
//     }
//     if (loginCredintials?.roleAccess) {
//       loginCredintials.roleAccess.forEach((each) => {
//         if (each.subModule === "booking_register") {
//           if (each.access.create) {
//             setCreateAccess(true);
//           }
//           if (each.access.update) {
//             setModifyAccess(true);
//           }
//           if (each.access.delete) {
//             setDeleteAccess(true);
//           }
//         }
//       });
//     }
//   }, [loginCredintials]);

//   // Memoize getAllBooking to prevent recreation
//   const getAllBooking = useCallback((value = null, status, val) => {
//     setSpinning(true);
//     if (!status) {
//       status = tab;
//       if (!tab) {
//         status = "PENDING"
//       }
//     }
//     platformApi
//       .post("/api/booking/get", {
//         page: val ? val : page,
//         size: limit,
//         branch: loginCredintials.branch.id,
//         searchString: value,
//         status,
//       })
//       .then((res) => {
//         setSpinning(false);
//         let { data } = res;
//         if (data.code === 200) {
//           let { response } = data;
//           if (response.code === 200) {
//             setBookingsData(response.data.booking);
//             setCount(response.data.count);
//           } else {
//             message.error("Failed to fetch booking");
//           }
//         } else {
//           message.error("Failed to fetch booking");
//         }
//       })
//       .catch((error) => {
//         setSpinning(false);
//         console.error("Error on booking : ", error);
//         message.error("Failed to fetch booking");
//       });
//   }, [loginCredintials.branch.id, page, limit, tab]);

//   useEffect(() => {
//     getAllBooking(search);
//   }, [page, limit, search, getAllBooking]);

//   useEffect(() => {
//     getAllBooking();
//     const bookingState = localStorage.getItem("bookingState");

//     if (bookingState) {
//       try {
//         const { addFlag, id, bookingStatus } = JSON.parse(bookingState);
//         setBookingType(bookingStatus === "ADVANCE" ? "AdvancedBooking" : "ConfirmBooking");

//         if (addFlag && id) {
//           openModal(id, false);
//         }

//         // Clean up after using
//         localStorage.removeItem("bookingState");
//       } catch (error) {
//         console.error("Error parsing bookingState:", error);
//         localStorage.removeItem("bookingState");
//       }
//     }
//   }, []); // eslint-disable-line react-hooks/exhaustive-deps

//   // Memoize getSelectedBooking
//   const getSelectedBooking = useCallback((id, isChassis = false) => {
//     platformApi
//       .get(`/api/booking/${id}`)
//       .then((res) => {
//         let { data } = res;
//         if (data.code === 200) {
//           // resilient response handling
//           const responseData = data.response?.code === 200 ? data.response.data : (data.response || data.data);

//           if (responseData) {
//             //to remove customer verification on modify
//             if (editFlag && addFlag) {
//               responseData.authentication = {
//                 afterVerification: null,
//                 beforeVerification: null,
//                 digital: null,
//                 id: responseData.authentication?.id || null,
//                 manual: null,
//                 verifiedAt: null,
//               };
//             }
//             setSelectedBooking(responseData);
//             if (!isChassis) {
//               setAddFlag(true);
//             }
//           }
//         }
//       })
//       .catch((error) => {
//         console.error("Error on booking : ", error);
//       });
//   }, [editFlag, addFlag]);

//   // Memoize deleteData
//   const deleteData = useCallback((id) => {
//     setSpinning(true);
//     let temp = page != 1 && bookingsData.length === 1;
//     platformApi
//       .delete("/api/booking/" + id)
//       .then((result) => {
//         setSpinning(false);
//         let { data } = result;
//         if (data.code === 200) {
//           let { response } = data;
//           if (response.code === 200) {
//             if (temp) {
//               setPage(1);
//               getAllBooking(null, null, 1);
//             } else {
//               getAllBooking();
//             }
//             message.success("Deleted Sucessfully", 2);
//           } else {
//             message.error("Unable to delete Booking", 2);
//           }
//         } else {
//           message.error("Unable to delete booking", 2);
//         }
//       })
//       .catch((error) => {
//         setSpinning(false);
//         console.error("Error on booking : ", error);
//         message.error("Unable to delete booking", 2);
//       });
//   }, [page, bookingsData.length, getAllBooking]);

//   // Memoize openPaymentModal
//   const openPaymentModal = useCallback((row) => {
//     setSelectedRow(row);
//     setPaymentModalVisible(true);
//   }, []);

//   // Memoize setEReceipt
//   const setEReceipt = useCallback(async (payload) => {
//     try {
//       const res = await platformApi.post("/api/idGenerate/e-receipt", payload);
//       let { data } = res;

//       if (data.code === 200) {
//         return data.response.data;   // eReceiptId
//       } else {
//         message.error("Couldn't fetch e-receipt id");
//         return null;
//       }
//     } catch (err) {
//       console.error("Error fetching e-receipt ID:", err);
//       message.error("Couldn't fetch e-receipt id");
//       return null;
//     }
//   }, []);

//   // Memoize setBooking
//   const setBooking = useCallback(async (payload) => {
//     try {
//       const res = await platformApi.post("/api/idGenerate/booking", payload);
//       let { data } = res;
//       if (data.code === 200) {
//         let { response } = data;
//         setBookingId(response.data);
//         return response.data;
//       } else {
//         message.error("Couldn't fetch id");
//         return null;
//       }
//     } catch (err) {
//       console.error("Error fetching booking ID:", err);
//       message.error("Couldn't fetch id");
//       return null;
//     }
//   }, []);

//   // Memoize addData
//   const addData = useCallback(async (bookingRegister, showMessage = false) => {
//     let bookingId = await setBooking({ branch: bookingRegister?.branch?.id });
//     bookingRegister.bookingId = bookingId;
//     let eReceiptId = await setEReceipt({ branch: bookingRegister?.branch?.id });
//     bookingRegister.eReceiptId = eReceiptId;

//     setSpinning(true);

//     try {
//       if (confirm) {
//         bookingRegister.bookingStatus = "PENDING";
//         bookingRegister.isAdvanceBooking = false;

//         // try {
//         //   const confirmRes = await platformApi.post("/api/idGenerate/confirmBooking", {
//         //     branch: bookingRegister?.branch?.id,
//         //   });

//         //   const confirmId = confirmRes?.data?.response?.data;
//         //   if (confirmId) {
//         //     bookingRegister.confirmBookingId = confirmId;
//         //   } else {
//         //     message.error(confirmRes?.data?.response?.message || "No confirmBookingId returned from API");
//         //     console.warn(confirmRes?.data?.response?.message || "No confirmBookingId returned from API");
//         //   }
//         // } catch (error) {
//         //   console.error("Error fetching confirmBookingId:", error);
//         //   message.error("Unable to generate confirm booking ID", 1);
//         // }
//       }

//       let response;

//       if (bookingRegister.id) {
//         const res = await platformApi.put(
//           `/api/booking/${bookingRegister.id}`,
//           bookingRegister
//         );
//         response = res.data.response;
//       } else {

//         // if(bookingType == "ConfirmBooking"){
//         //   try {
//         //     const confirmRes = await platformApi.post("/api/idGenerate/confirmBooking", {
//         //       branch: bookingRegister?.branch?.id,
//         //     });

//         //     const confirmId = confirmRes?.data?.response?.data;
//         //     if (confirmId) {
//         //       bookingRegister.confirmBookingId = confirmId;
//         //     } else {
//         //       console.warn("No confirmBookingId returned from API");
//         //     }
//         //   } catch (error) {
//         //     console.error("Error fetching confirmBookingId:", error);
//         //     message.error("Unable to generate confirm booking ID", 1);
//         //   }
//         // }

//         const res = await platformApi.post("/api/booking/create", bookingRegister);
//         response = res.data.response;
//       }

//       setSpinning(false);

//       if (response && response.code === 200) {
//         setSelectedBooking(response.data);
//         setBookingId(response.data.bookingId);
//         await getAllBooking();

//         if (response.data.bookingStatus === "ACCEPTED") {
//           sendConfirmSMS(response.data);
//         }

//         showMessage && message.success("Booking saved successfully", 1);
//       } else {
//         message.error("Error in booking operation");
//       }
//     } catch (err) {
//       setSpinning(false);
//       console.error("Error on booking:", err);
//       message.error("Unable to save booking", 1);
//     }
//   }, [confirm, setBooking, setEReceipt, getAllBooking]);

//   // Memoize updateDataStatus
//   const updateDataStatus = useCallback((reason, id, cancellationAmount) => {
//     platformApi
//       .put(`/api/booking/updateStatus/${id}`, {
//         reason,
//         cancellationAmount: cancellationAmount || 0,
//         bookingStatus: "REJECTED",
//       })
//       .then((res) => {
//         let { data } = res;
//         if (data.code === 200) {
//           message.success("Booking Status Updated successfully", 2);
//           getAllBooking();
//         }
//       })
//       .catch((err) => {
//         message.error("Unable to update Booking Status", 2);
//         console.error("Error on Booking Status : ", err);
//       });
//   }, [getAllBooking]);

//   // Memoize sendConfirmSMS
//   const sendConfirmSMS = useCallback((data) => {
//     const {
//       bookingId,
//       branch,
//       executive: {
//         profile: { employeeName },
//       },
//       authentication,
//       customer: { name, contacts },
//       vehicle: { modelName },
//     } = data;
//     const phone = contacts[0].phone;
//     const smsdata = {
//       pdflink:
//         authentication.afterVerification || authentication.beforeVerification,
//       cname: name,
//       vname: modelName,
//       bkid: bookingId,
//       slex: employeeName,
//       clink: "-",
//       dlr: branch.name,
//     };
//     platformApi
//       .post("/api/sendSms/bookingconfirm", {
//         phone,
//         smsdata,
//       })
//       .then((res) => {
//         const { data } = res;
//         if (data.code === 200) {
//           message.success("Message sent successfully");
//         } else if (data.code === 401) {
//           message.error(data.message);
//         } else {
//           message.error("Unable to send SMS");
//         }
//       });
//   }, []);

//   // Memoize handleTabChange
//   const handleTabChange = useCallback((activeKey) => {
//     switch (activeKey) {
//       case "1":
//         getAllBooking(null, "ALL");
//         setTab("ALL");
//         setPage(1);
//         setBookingType("ConfirmBooking");
//         break;
//       case "2":
//         getAllBooking(null, "PENDING");
//         setTab("PENDING");
//         setPage(1);
//         setBookingType("ConfirmBooking");
//         break;
//       case "3":
//         getAllBooking(null, "ACCEPTED");
//         setTab("ACCEPTED");
//         setPage(1);
//         setBookingType("ConfirmBooking");
//         break;
//       case "4":
//         getAllBooking(null, "REJECTED");
//         setTab("REJECTED");
//         setPage(1);
//         setBookingType("ConfirmBooking");
//         break;
//       case "5":
//         getAllBooking(null, "ADVANCE");
//         setTab("ADVANCE");
//         setPage(1);
//         setBookingType("AdvancedBooking");
//         break;
//       case "6":
//         getAllBooking(null, "SOLD");
//         setTab("SOLD");
//         setPage(1);
//         setBookingType("ConfirmBooking");
//         break;
//       default:
//         getAllBooking(null, null);
//         setTab("ALL");
//         setPage(1);
//     }
//   }, [getAllBooking]);

//   // Memoize openModal
//   const openModal = useCallback((id, editable) => {
//     getSelectedBooking(id);
//     setEditFlag(editable);
//     setAddFlag(true);
//   }, [getSelectedBooking]);

//   // Memoize menu
//   const menu = useMemo(() => <Menu>{menuItems}</Menu>, [menuItems]);

//   // Memoize pagination config
//   const paginationConfig = useMemo(() => ({
//     onChange: (page) => setPage(page),
//     pageSize: limit,
//     defaultCurrent: 1,
//     total: count,
//     current: page,
//     showQuickJumper: true,
//   }), [limit, count, page]);

//   // Memoize all callback functions at top level (hooks must be called unconditionally)
//   const handleSearch = useCallback((event) => {
//     setPage(1);
//     setSearch(event);
//   }, []);

//   const handleSearchChange = useCallback((event) => {
//     if (event.target.value === "") {
//       setSearch(null);
//       setPage(1);
//     }
//   }, []);

//   const handleOpenModalPending = useCallback((id, editable) => {
//     getSelectedBooking(id);
//     setEditFlag(editable);
//   }, [getSelectedBooking]);

//   const handleOpenModalAuthorized = useCallback((id, editable) => {
//     getSelectedBooking(id);
//     setEditFlag(editable);
//   }, [getSelectedBooking]);

//   const handleOpenChassisModal = useCallback((id, editable) => {
//     getSelectedBooking(id, true);
//     setEditFlag(editable);
//     setChassisModal(true);
//   }, [getSelectedBooking]);

//   const handleOpenModalSold = useCallback((id, editable) => {
//     getSelectedBooking(id);
//     setEditFlag(editable);
//   }, [getSelectedBooking]);

//   const handleOpenModalCancelled = useCallback((id, editable) => {
//     getSelectedBooking(id);
//     setEditFlag(editable);
//   }, [getSelectedBooking]);

//   const handleOpenModalAdvanced = useCallback((id, editable, modalRequired) => {
//     if (modalRequired) setConfirm(true);
//     getSelectedBooking(id);
//     setEditFlag(editable);
//   }, [getSelectedBooking]);

//   const handleOpenModalAll = useCallback((id, editable) => {
//     getSelectedBooking(id);
//     setEditFlag(false);
//   }, [getSelectedBooking]);

//   const handleCloseBookingModal = useCallback(() => {
//     setAddFlag(false);
//     setBFlag(false);
//     getAllBooking();
//     setConfirm(false);
//   }, [getAllBooking]);

//   const handleCloseChassisModal = useCallback(() => {
//     setChassisModal(false);
//     setSelectedBooking(null);
//     setBFlag(false);
//     getAllBooking();
//     setConfirm(false);
//   }, [getAllBooking]);

//   const handleClosePaymentModal = useCallback(() => {
//     setPaymentModalVisible(false);
//   }, []);

//   const handlePaymentSuccess = useCallback(() => {
//     getAllBooking();
//     setPaymentModalVisible(false);
//   }, [getAllBooking]);

//   return (
//     <div>
//       <div className="accessories-head">
//         <Title style={{ width: "60%" }} level={4}>
//           Booking Register [{count}]
//           <span style={{ margin: ".5rem" }}>
//             <Dropdown overlay={menu} trigger={["click"]}>
//               <Button>
//                 {limit} &nbsp;
//                 <Icon type="down" />
//               </Button>
//             </Dropdown>
//           </span>
//         </Title>
//         <Search
//           style={{ width: "30%" }}
//           placeholder="Search Booking"
//           onSearch={handleSearch}
//           onChange={handleSearchChange}
//         />
//         <div style={{ display: "flex" }}>
//           <Button
//             onClick={() => {
//               setAddFlag(true);
//               setEditFlag(true);
//               // setBooking();
//               setSelectedBooking(defaultData);
//               setBookingType("ConfirmBooking");
//             }}
//             style={{ margin: "0 1%", width: "50%" }}
//             type="primary"
//             disabled={!createAccess}
//           >
//             Confirm Booking
//           </Button>
//           <Button
//             onClick={() => {
//               setAddFlag(true);
//               setEditFlag(true);
//               // setBooking();
//               setSelectedBooking(defaultData);
//               setBookingType("AdvancedBooking");
//             }}
//             style={{ margin: "0 1%", width: "50%" }}
//             type="primary"
//             disabled={!createAccess}
//           >
//             Advanced Booking
//           </Button>
//         </div>
//       </div>
//       <Tabs defaultActiveKey="2" onChange={handleTabChange}>
//         <TabPane tab={<span>Unauthorized Bookings</span>} key="2">
//           <BookingRegisterTable
//             pagination={paginationConfig}
//             openPaymentModal={openPaymentModal}
//             refreshData={getAllBooking}
//             type={"pending"}
//             openModal={handleOpenModalPending}
//             onDelete={deleteData}
//             dataSource={bookingsData}
//             spinner={{ spinning }}
//           />
//         </TabPane>
//         <TabPane tab={<span>Authorized Bookings</span>} key="3">
//           <BookingRegisterTable
//             openPaymentModal={openPaymentModal}
//             pagination={paginationConfig}
//             openModal={handleOpenModalAuthorized}
//             refreshData={getAllBooking}
//             openChassisModal={handleOpenChassisModal}
//             type={"authorized"}
//             onDelete={deleteData}
//             dataSource={bookingsData}
//             spinner={{ spinning }}
//             loginCredintials={loginCredintials}
//             modify={modifyAccess}
//             deleteAccess={deleteAccess}
//           />
//         </TabPane>
//         <TabPane tab={<span>Sold Bookings</span>} key="6">
//           <BookingRegisterTable
//             pagination={paginationConfig}
//             openModal={handleOpenModalSold}
//             type={"sold"}
//             onDelete={deleteData}
//             dataSource={bookingsData}
//             spinner={{ spinning }}
//             loginCredintials={loginCredintials}
//             modify={true}
//             deleteAccess={deleteAccess}
//           />
//         </TabPane>
//         <TabPane tab={<span>Cancelled Bookings</span>} key="4">
//           <BookingRegisterTable
//             pagination={paginationConfig}
//             openModal={handleOpenModalCancelled}
//             type={"cancelled"}
//             onDelete={deleteData}
//             dataSource={bookingsData}
//             spinner={{ spinning }}
//             refreshData={getAllBooking}
//           />
//         </TabPane>
//         <TabPane tab={<span>Advanced Bookings</span>} key="5">
//           <BookingRegisterTable
//             openPaymentModal={openPaymentModal}
//             pagination={paginationConfig}
//             type={"advanced"}
//             openModal={handleOpenModalAdvanced}
//             refreshData={getAllBooking}
//             onDelete={deleteData}
//             dataSource={bookingsData}
//             spinner={{ spinning }}
//             modify={modifyAccess}
//             deleteAccess={deleteAccess}
//             advancedBookingModifyAccess={true}
//             updateDataStatus={updateDataStatus}
//           />
//         </TabPane>
//         <TabPane tab={<span>All Bookings</span>} key="1">
//           <BookingRegisterTable
//             pagination={paginationConfig}
//             type={"ALL"}
//             openModal={handleOpenModalAll}
//             onDelete={deleteData}
//             dataSource={bookingsData}
//             spinner={{ spinning }}
//           />
//         </TabPane>
//         <TabPane tab={<span>Booking History</span>} key="7">
//           <BookingHistoryTable />
//         </TabPane>
//       </Tabs>
//       {addFlag && <BookingRegisterModal
//         mode={
//           bookingType === "AdvancedBooking" && confirm === true
//             ? "ConfirmBooking"
//             : bookingType
//         }
//         id={bookingId}
//         currentData={selectedBooking}
//         emitData={addData}
//         editable={editFlag}
//         isSales={false}
//         open={addFlag}
//         setBFlag={setBFlag}
//         bFlag={bFlag}
//         clearBookingData={setSelectedBooking}
//         close={handleCloseBookingModal}
//       />}
//       {chassisModal && <ChassisAllocationModal
//         id={bookingId}
//         data={selectedBooking}
//         emitData={addData}
//         editable={editFlag}
//         open={chassisModal}
//         setBFlag={setBFlag}
//         bFlag={bFlag}
//         clearBookingData={setSelectedBooking}
//         close={handleCloseChassisModal}
//       />}
//       {paymentModalVisible && (
//         <PaymentModal
//           visible={paymentModalVisible}
//           onClose={handleClosePaymentModal}
//           module="BOOKING_REGISTER"
//           moduleId={selectedRow?.id}
//           branchId={selectedRow?.branch?.id}
//           vehPrice={selectedRow?.vehicle?.price?.[0]?.showroomPrice}
//           balanceAmount={selectedRow?.price?.finalAmount}
//           onSuccess={handlePaymentSuccess}
//         />
//       )}

//     </div>
//   );
// }
import React, { useState, useEffect, useContext, useRef, useMemo, useCallback } from "react";
import {
  Typography,
  Input,
  Button,
  Dropdown,
  Menu,
  Icon,
  message,
  Result,
  Tabs,
} from "antd";
import { platformApi } from "../../../api";
import BookingRegisterTable from "./BookingRegisterTable";
import BookingRegisterModal from "./BookingRegisterModal";
import ChassisAllocationModal from "./ChassisAllocationModal";
import PaymentModal from "../../paymentModal";
import { ContextAPI } from "../../../ContextAPI";
import { useLocation } from "react-router-dom";
import BookingHistoryTable from "./BookingHistoryTable";
import { useBranch, getDistance } from "../../../ContextAPI/branch";
import "./index.less";

const { Title } = Typography;
const { Search } = Input;
const { Item } = Menu;
const { TabPane } = Tabs;

// default data structure
const defaultData = {
  bookingId: null,
  customer: null,
  customerId: null,
  customerName: null,
  customerFatherName: null,
  customerAddress: null,
  customerPhone: null,
  customerLocality: null,
  customerCountry: null,
  customerState: null,
  customerCity: null,
  customerPincode: null,
  customerEmail: null,
  customerDob: null,
  customerGender: null,
  IDbranch: null,
  nomineeName: null,
  nomineeAge: null,
  relationship: null,
  vehicle: null,
  rto: null,
  rtoCode: null,
  rtoArea: null,
  exchangeVehicleName: null,
  exchangeVehiclePrice: null,
  price: null,
  accessories: [],
  quotation: [],
  color: null,
  loan: null,
  authentication: null,
  pdf: "example",
  pdfSigned: "example",
  executive: null,
  remarks: null,
  bookingStatus: null,
  authorisedTime: null,
  refferedBy: null,
};

export default function Bookingregister() {
  const [addFlag, setAddFlag] = useState(false);
  const [editFlag, setEditFlag] = useState(false);
  const [bookingType, setBookingType] = useState("ConfirmBooking");
  const [spinning, setSpinning] = useState(false);
  const [bookingId, setBookingId] = useState("");
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [bookingsData, setBookingsData] = useState([]);
  const [bFlag, setBFlag] = useState(false);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(null);
  const [tabCounts, setTabCounts] = useState({
    ADVANCE: 0,
    PENDING: 0,
    ACCEPTED: 0,
    SOLD: 0,
    REJECTED: 0,
    ALL: 0,
  });
  const [search, setSearch] = useState(null);
  const [tab, setTab] = useState("ADVANCE");
  const { loginCredintials } = useContext(ContextAPI);
  const { branches, selectBranch } = useBranch();
  const [createAccess, setCreateAccess] = useState(false);
  const [modifyAccess, setModifyAccess] = useState(false);
  const [deleteAccess, setDeleteAccess] = useState(false);
  const [gst, setGst] = useState();
  const [confirm, setConfirm] = useState(false);
  const [chassisModal, setChassisModal] = useState(false);
  const [paymentModalVisible, setPaymentModalVisible] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const location = useLocation();

  // Memoize menu items to prevent recreation
  const menuItems = useMemo(() => {
    if (!count) return [];
    let size = Math.ceil(count / 10);
    let menus = [10];
    size = size <= 10 ? size : 10;
    for (let itr = 2; itr <= size; itr++) menus.push(itr * 10);
    return menus.map((menu) => (
      <Item
        onClick={() => {
          setLimit(menu);
          setPage(1);
        }}
        key={menu}
      >
        {menu}
      </Item>
    ));
  }, [count]);

  useEffect(() => {
    if (loginCredintials?.branch?.[0]?.gst) {
      setGst(loginCredintials.branch[0].gst);
    }
    if (loginCredintials?.roleAccess) {
      loginCredintials.roleAccess.forEach((each) => {
        if (each.subModule === "booking_register") {
          if (each.access.create) setCreateAccess(true);
          if (each.access.update) setModifyAccess(true);
          if (each.access.delete) setDeleteAccess(true);
        }
      });
    }
  }, [loginCredintials]);

  const getBranchIds = useCallback(() => {
    if (selectBranch && selectBranch.length > 0) {
      return selectBranch.map((b) => b.id);
    }
    return [loginCredintials.branch.id];
  }, [selectBranch, loginCredintials.branch.id]);

  const fetchTabCounts = useCallback(
    (searchString = null) => {
      const statuses = [
        "ADVANCE",
        "PENDING",
        "ACCEPTED",
        "SOLD",
        "REJECTED",
        "ALL",
      ];
      const branch = getBranchIds();
      Promise.all(
        statuses.map((status) =>
          platformApi
            .post("/api/booking/get", {
              page: 1,
              size: 1,
              branch,
              searchString,
              status,
            })
            .then((res) => {
              const countVal =
                res?.data?.response?.data?.count ??
                res?.data?.data?.count ??
                0;
              return { status, count: countVal };
            })
            .catch(() => ({ status, count: 0 }))
        )
      ).then((results) => {
        const next = {};
        results.forEach(({ status, count: c }) => {
          next[status] = c;
        });
        setTabCounts((prev) => ({ ...prev, ...next }));
      });
    },
    [getBranchIds]
  );

  // Memoize getAllBooking to prevent recreation
  const getAllBooking = useCallback((value = null, status, val) => {
    setSpinning(true);
    if (!status) {
      status = tab;
      if (!tab) status = "ADVANCE";
    }
    platformApi
      .post("/api/booking/get", {
        page: val ? val : page,
        size: limit,
        branch: getBranchIds(),
        searchString: value,
        status,
      })
      .then((res) => {
        setSpinning(false);
        let { data } = res;
        if (data.code === 200) {
          let { response } = data;
          if (response.code === 200) {
            setBookingsData(response.data.booking);
            setCount(response.data.count);
            if (status) {
              setTabCounts((prev) => ({
                ...prev,
                [status]: response.data.count,
              }));
            }
          } else {
            message.error("Failed to fetch booking");
          }
        } else {
          message.error("Failed to fetch booking");
        }
      })
      .catch((error) => {
        setSpinning(false);
        console.error("Error on booking : ", error);
        // message.error("Failed to fetch booking");
      });
  }, [getBranchIds, page, limit, tab]);

  useEffect(() => {
    getAllBooking(search);
  }, [page, limit, search, getAllBooking]);

  useEffect(() => {
    fetchTabCounts(search);
  }, [fetchTabCounts, search, selectBranch]);

  useEffect(() => {
    getAllBooking();
    const bookingState = localStorage.getItem("bookingState");
    if (bookingState) {
      try {
        const { addFlag, id, bookingStatus } = JSON.parse(bookingState);
        setBookingType(bookingStatus === "ADVANCE" ? "AdvancedBooking" : "ConfirmBooking");
        if (addFlag && id) openModal(id, false);
        localStorage.removeItem("bookingState");
      } catch (error) {
        console.error("Error parsing bookingState:", error);
        localStorage.removeItem("bookingState");
      }
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Memoize getSelectedBooking
  const getSelectedBooking = useCallback((id, isChassis = false) => {
    platformApi
      .get(`/api/booking/${id}`)
      .then((res) => {
        let { data } = res;
        if (data.code === 200) {
          const responseData =
            data.response?.code === 200
              ? data.response.data
              : data.response || data.data;

          if (responseData) {
            if (editFlag && addFlag) {
              responseData.authentication = {
                afterVerification: null,
                beforeVerification: null,
                digital: null,
                id: responseData.authentication?.id || null,
                manual: null,
                verifiedAt: null,
              };
            }
            setSelectedBooking(responseData);
            if (!isChassis) setAddFlag(true);
          }
        }
      })
      .catch((error) => {
        console.error("Error on booking : ", error);
      });
  }, [editFlag, addFlag]);

  // Memoize deleteData
  const deleteData = useCallback((id) => {
    setSpinning(true);
    let temp = page != 1 && bookingsData.length === 1;
    platformApi
      .delete("/api/booking/" + id)
      .then((result) => {
        setSpinning(false);
        let { data } = result;
        if (data.code === 200) {
          let { response } = data;
          if (response.code === 200) {
            if (temp) {
              setPage(1);
              getAllBooking(null, null, 1);
            } else {
              getAllBooking();
            }
            message.success("Deleted Sucessfully", 2);
          } else {
            message.error("Unable to delete Booking", 2);
          }
        } else {
          message.error("Unable to delete booking", 2);
        }
      })
      .catch((error) => {
        setSpinning(false);
        console.error("Error on booking : ", error);
        message.error("Unable to delete booking", 2);
      });
  }, [page, bookingsData.length, getAllBooking]);

  // Memoize openPaymentModal
  const openPaymentModal = useCallback((row) => {
    setSelectedRow(row);
    setPaymentModalVisible(true);
  }, []);

  // Memoize setEReceipt
  const setEReceipt = useCallback(async (payload) => {
    // API call removed: Backend now generates the e-receipt ID internally
    return "GENERATED_BY_BACKEND";
  }, []);

  // Memoize setBooking
  const setBooking = useCallback(async (payload) => {
    try {
      const res = await platformApi.post("/api/idGenerate/booking", payload);
      let { data } = res;
      if (data.code === 200) {
        let { response } = data;
        setBookingId(response.data);
        return response.data;
      } else {
        message.error("Couldn't fetch id");
        return null;
      }
    } catch (err) {
      console.error("Error fetching booking ID:", err);
      message.error("Couldn't fetch id");
      return null;
    }
  }, []);

  /**
   * addData
   *
   * @param {object}  bookingRegister  - the full booking payload
   * @param {boolean} changeTab        - whether to advance the step (passed through from modal)
   * @param {boolean} skipApi          - when TRUE the function only stores data locally and
   *                                     does NOT call the booking API.
   *                                     Used for Confirm Booking Step 3 (Payment) so no
   *                                     duplicate record is created; the real API call happens
   *                                     in Step 4 (Authentication / DownloadData).
   */
  const addData = useCallback(async (bookingRegister, changeTab = false, skipApi = false) => {
    // ── CONFIRM BOOKING – PAYMENT STEP (Step 3) ──────────────────────────────
    // Just store the payload in selectedBooking so Step 4 can pick it up.
    // No IDs are generated, no API is called, no toast is shown here.
    if (skipApi) {
      setSelectedBooking((prev) => ({ ...prev, ...bookingRegister }));
      return;
    }

    // ── ALL OTHER CASES (Advanced Booking Step 3, Confirm Booking Step 4) ────
    let newBookingId = await setBooking({ branch: bookingRegister?.branch?.id });
    bookingRegister.bookingId = newBookingId;
    let eReceiptId = await setEReceipt({ branch: bookingRegister?.branch?.id });
    bookingRegister.eReceiptId = eReceiptId;

    setSpinning(true);

    try {
      if (confirm) {
        bookingRegister.bookingStatus = "PENDING";
        bookingRegister.isAdvanceBooking = false;
      }

      let response;

      if (bookingRegister.id) {
        const res = await platformApi.put(
          `/api/booking/${bookingRegister.id}`,
          bookingRegister
        );
        response = res.data.response;
      } else {
        const res = await platformApi.post("/api/booking/create", bookingRegister);
        response = res.data.response;
      }

      setSpinning(false);

      if (response && response.code === 200) {
        setSelectedBooking(response.data);
        setBookingId(response.data.bookingId);
        await getAllBooking();

        if (response.data.bookingStatus === "ACCEPTED") {
          sendConfirmSMS(response.data);
        }

        // ── Toast: show success only when the booking is actually persisted ──
        message.success("Booking created successfully", 2);
      } else {
        message.error("Error in booking operation");
      }
    } catch (err) {
      setSpinning(false);
      console.error("Error on booking:", err);
      message.error("Unable to save booking", 1);
    }
  }, [confirm, setBooking, setEReceipt, getAllBooking]);

  // Memoize updateDataStatus
  const updateDataStatus = useCallback((reason, id, cancellationAmount) => {
    platformApi
      .put(`/api/booking/updateStatus/${id}`, {
        reason,
        cancellationAmount: cancellationAmount || 0,
        bookingStatus: "REJECTED",
      })
      .then((res) => {
        let { data } = res;
        if (data.code === 200) {
          message.success("Booking Status Updated successfully", 2);
          getAllBooking();
        }
      })
      .catch((err) => {
        message.error("Unable to update Booking Status", 2);
        console.error("Error on Booking Status : ", err);
      });
  }, [getAllBooking]);

  // Memoize sendConfirmSMS
  const sendConfirmSMS = useCallback((data) => {
    const {
      bookingId,
      branch,
      executive: { profile: { employeeName } },
      authentication,
      customer: { name, contacts },
      vehicle: { modelName },
    } = data;
    const phone = contacts[0].phone;
    const smsdata = {
      pdflink: authentication.afterVerification || authentication.beforeVerification,
      cname: name,
      vname: modelName,
      bkid: bookingId,
      slex: employeeName,
      clink: "-",
      dlr: branch.name,
    };
    platformApi
      .post("/api/sendSms/bookingconfirm", { phone, smsdata })
      .then((res) => {
        const { data } = res;
        if (data.code === 200) {
          message.success("Message sent successfully");
        } else if (data.code === 401) {
          message.error(data.message);
        } else {
          message.error("Unable to send SMS");
        }
      });
  }, []);

  // Memoize handleTabChange
  const handleTabChange = useCallback((activeKey) => {
    switch (activeKey) {
      case "1":
        getAllBooking(null, "ALL");
        setTab("ALL"); setPage(1); setBookingType("ConfirmBooking");
        break;
      case "2":
        getAllBooking(null, "PENDING");
        setTab("PENDING"); setPage(1); setBookingType("ConfirmBooking");
        break;
      case "3":
        getAllBooking(null, "ACCEPTED");
        setTab("ACCEPTED"); setPage(1); setBookingType("ConfirmBooking");
        break;
      case "4":
        getAllBooking(null, "REJECTED");
        setTab("REJECTED"); setPage(1); setBookingType("ConfirmBooking");
        break;
      case "5":
        getAllBooking(null, "ADVANCE");
        setTab("ADVANCE"); setPage(1); setBookingType("AdvancedBooking");
        break;
      case "6":
        getAllBooking(null, "SOLD");
        setTab("SOLD"); setPage(1); setBookingType("ConfirmBooking");
        break;
      default:
        getAllBooking(null, null);
        setTab("ALL"); setPage(1);
    }
  }, [getAllBooking]);

  // Memoize openModal
  const openModal = useCallback((id, editable) => {
    getSelectedBooking(id);
    setEditFlag(editable);
    setAddFlag(true);
  }, [getSelectedBooking]);

  // Memoize menu
  const menu = useMemo(() => <Menu>{menuItems}</Menu>, [menuItems]);

  const renderTabLabel = useCallback(
    (label, statusKey) => (
      <span className="register-tab-label">
        <span>{label}</span>
        <span className="register-tab-count">
          {tabCounts[statusKey] ?? 0}
        </span>
      </span>
    ),
    [tabCounts]
  );

  // Memoize pagination config
  const paginationConfig = useMemo(() => ({
    onChange: (page) => setPage(page),
    pageSize: limit,
    defaultCurrent: 1,
    total: count,
    current: page,
    showQuickJumper: true,
  }), [limit, count, page]);

  const handleSearch = useCallback((event) => {
    setPage(1);
    setSearch(event);
  }, []);

  const handleSearchChange = useCallback((event) => {
    if (event.target.value === "") {
      setSearch(null);
      setPage(1);
    }
  }, []);

  const handleOpenModalPending = useCallback((id, editable) => {
    getSelectedBooking(id);
    setEditFlag(editable);
  }, [getSelectedBooking]);

  const handleOpenModalAuthorized = useCallback((id, editable) => {
    getSelectedBooking(id);
    setEditFlag(editable);
  }, [getSelectedBooking]);

  const handleOpenChassisModal = useCallback((id, editable) => {
    getSelectedBooking(id, true);
    setEditFlag(editable);
    setChassisModal(true);
  }, [getSelectedBooking]);

  const handleOpenModalSold = useCallback((id, editable) => {
    getSelectedBooking(id);
    setEditFlag(editable);
  }, [getSelectedBooking]);

  const handleOpenModalCancelled = useCallback((id, editable) => {
    getSelectedBooking(id);
    setEditFlag(editable);
  }, [getSelectedBooking]);

  const handleOpenModalAdvanced = useCallback((id, editable, modalRequired) => {
    if (modalRequired) {
      // "Confirm" button clicked: upgrading an advance booking to a confirm booking
      setConfirm(true);
      setBookingType("ConfirmBooking");
    } else {
      // "Modify" button clicked: open as Advanced Booking (no mandatory extra fields)
      setBookingType("AdvancedBooking");
    }
    getSelectedBooking(id);
    setEditFlag(editable);
  }, [getSelectedBooking]);

  const handleOpenModalAll = useCallback((id, editable) => {
    getSelectedBooking(id);
    setEditFlag(false);
  }, [getSelectedBooking]);

  const handleCloseBookingModal = useCallback(() => {
    setAddFlag(false);
    setBFlag(false);
    getAllBooking();
    setConfirm(false);
  }, [getAllBooking]);

  const handleCloseChassisModal = useCallback(() => {
    setChassisModal(false);
    setSelectedBooking(null);
    setBFlag(false);
    getAllBooking();
    setConfirm(false);
  }, [getAllBooking]);

  const handleClosePaymentModal = useCallback(() => {
    setPaymentModalVisible(false);
  }, []);

  const handlePaymentSuccess = useCallback(() => {
    getAllBooking();
    setPaymentModalVisible(false);
  }, [getAllBooking]);

  return (
    <div>
      <div className="accessories-head register-page-head">
        <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
          <h3 className="register-page-title">Booking Register</h3>
          {/* <Dropdown overlay={menu} trigger={["click"]}>
            <Button>
              {limit} &nbsp;
              <Icon type="down" />
            </Button> 
          </Dropdown> */}
        </div>
        <div className="register-page-toolbar">
          <Search
            style={{ width: 220 }}
            placeholder="Search bookings..."
            onSearch={handleSearch}
            onChange={handleSearchChange}
          />
          <Button
            onClick={() => {
              setAddFlag(true);
              setEditFlag(true);
              setSelectedBooking(defaultData);
              setBookingType("ConfirmBooking");
            }}
            type="primary"
            className="register-page-btn-primary"
            disabled={!createAccess}
          >
            Confirm Booking
          </Button>
          <Button
            onClick={() => {
              setAddFlag(true);
              setEditFlag(true);
              setSelectedBooking(defaultData);
              setBookingType("AdvancedBooking");
              if (navigator.geolocation && branches && branches.length > 0) {
                navigator.geolocation.getCurrentPosition((position) => {
                  const lat = position.coords.latitude;
                  const lon = position.coords.longitude;
                  branches.forEach(branch => {
                    if (branch.lat && branch.lon) {
                      const dist = getDistance(lat, lon, branch.lat, branch.lon);
                      console.log(`Distance to ${branch.name}: ${dist.toFixed(2)} km`);
                    }
                  });
                });
              }
            }}
            type="primary"
            className="register-page-btn-primary"
            disabled={!createAccess}
          >
            Advanced Booking
          </Button>
        </div>
      </div>

      <Tabs className="register-page-tabs" defaultActiveKey="5" onChange={handleTabChange}>
        <TabPane tab={renderTabLabel("Advanced Bookings", "ADVANCE")} key="5">
          <BookingRegisterTable
            openPaymentModal={openPaymentModal}
            pagination={paginationConfig}
            type={"advanced"}
            openModal={handleOpenModalAdvanced}
            refreshData={getAllBooking}
            onDelete={deleteData}
            dataSource={bookingsData}
            spinner={{ spinning }}
            modify={modifyAccess}
            deleteAccess={deleteAccess}
            advancedBookingModifyAccess={true}
            updateDataStatus={updateDataStatus}
          />
        </TabPane>
        <TabPane tab={renderTabLabel("Unauthorized", "PENDING")} key="2">
          <BookingRegisterTable
            pagination={paginationConfig}
            openPaymentModal={openPaymentModal}
            refreshData={getAllBooking}
            type={"pending"}
            openModal={handleOpenModalPending}
            onDelete={deleteData}
            dataSource={bookingsData}
            spinner={{ spinning }}
          />
        </TabPane>
        <TabPane tab={renderTabLabel("Authorized", "ACCEPTED")} key="3">
          <BookingRegisterTable
            openPaymentModal={openPaymentModal}
            pagination={paginationConfig}
            openModal={handleOpenModalAuthorized}
            refreshData={getAllBooking}
            openChassisModal={handleOpenChassisModal}
            type={"authorized"}
            onDelete={deleteData}
            dataSource={bookingsData}
            spinner={{ spinning }}
            loginCredintials={loginCredintials}
            modify={modifyAccess}
            deleteAccess={deleteAccess}
          />
        </TabPane>
        <TabPane tab={renderTabLabel("Sold Bookings", "SOLD")} key="6">
          <BookingRegisterTable
            pagination={paginationConfig}
            openModal={handleOpenModalSold}
            refreshData={getAllBooking}
            type={"sold"}
            onDelete={deleteData}
            dataSource={bookingsData}
            spinner={{ spinning }}
            loginCredintials={loginCredintials}
            modify={true}
            deleteAccess={deleteAccess}
          />
        </TabPane>
        <TabPane tab={renderTabLabel("Cancelled Bookings", "REJECTED")} key="4">
          <BookingRegisterTable
            pagination={paginationConfig}
            openModal={handleOpenModalCancelled}
            type={"cancelled"}
            onDelete={deleteData}
            dataSource={bookingsData}
            spinner={{ spinning }}
            refreshData={getAllBooking}
          />
        </TabPane>
        <TabPane tab={renderTabLabel("All Bookings", "ALL")} key="1">
          <BookingRegisterTable
            pagination={paginationConfig}
            type={"ALL"}
            openModal={handleOpenModalAll}
            refreshData={getAllBooking}
            onDelete={deleteData}
            dataSource={bookingsData}
            spinner={{ spinning }}
          />
        </TabPane>
        <TabPane tab={<span>Booking History</span>} key="7">
          <BookingHistoryTable />
        </TabPane>
      </Tabs>

      {addFlag && (
        <BookingRegisterModal
          mode={
            bookingType === "AdvancedBooking" && confirm === true
              ? "ConfirmBooking"
              : bookingType
          }
          id={bookingId}
          currentData={selectedBooking}
          emitData={addData}
          editable={editFlag}
          isSales={false}
          open={addFlag}
          setBFlag={setBFlag}
          bFlag={bFlag}
          clearBookingData={setSelectedBooking}
          close={handleCloseBookingModal}
        />
      )}

      {chassisModal && (
        <ChassisAllocationModal
          id={bookingId}
          data={selectedBooking}
          emitData={addData}
          editable={editFlag}
          open={chassisModal}
          setBFlag={setBFlag}
          bFlag={bFlag}
          clearBookingData={setSelectedBooking}
          close={handleCloseChassisModal}
        />
      )}

      {paymentModalVisible && (
        <PaymentModal
          visible={paymentModalVisible}
          onClose={handleClosePaymentModal}
          module="BOOKING_REGISTER"
          moduleId={selectedRow?.id}
          branchId={selectedRow?.branch?.id}
          vehPrice={selectedRow?.vehicle?.price?.[0]?.showroomPrice}
          balanceAmount={selectedRow?.price?.finalAmount}
          onSuccess={handlePaymentSuccess}
        />
      )}
    </div>
  );
}